import { useContext } from 'react';
import { Form } from 'react-bootstrap';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { FixingContext, useValidateFixing } from '@/App/tiles/orders/FixingOrder/FixingContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectFixingTime, selectFixingTimesOfSelectedType } from '@/store/orders/fixing/selectors.ts';

export const FixingTime = () => {
  const tileId = useContext(FixingContext).tileId;
  const fixingTime = useAppSelector((state) => selectFixingTime(state, tileId));
  const fixingTimesOfSelectedType = useAppSelector((state) => selectFixingTimesOfSelectedType(state, tileId));
  const track = useTrackEvent();

  const validateFixing = useValidateFixing();

  const handleChangePlace = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Fixing time changed');
    const newPlace = event.target.value;

    validateFixing({
      fixingTime: newPlace,
    });
  };

  return (
    <OrderRow labelId="order.fields.fixingTime">
      <Form.Select value={fixingTime} onChange={handleChangePlace} size="sm" data-e2e="trigger-selector">
        {fixingTimesOfSelectedType?.toSorted().map((fixingTime) => (
          <option key={fixingTime} value={fixingTime}>
            {fixingTime}
          </option>
        ))}
      </Form.Select>
    </OrderRow>
  );
};
